import compareVersions from 'compare-versions'
import {
  PROJECT_BACK_COMPATIBILITY_BEFORE,
  FRONTEND_COMPATIBILITY_BEFORE_2_5_370,
  FRONTEND_COMPATIBILITY_BEFORE_2_5_332
} from '~/versions'
import { correctAssets } from './helpers/correctAssets'
import ProjectTransitionAsset from '~/models/ProjectData/ProjectTransitionAsset'
import { correctAssetWidthNHeight } from './helpers/correctAssetWidthNHeight'
import { updateSourceMediaRefCountForOldProject } from './helpers/updateSourceMediaRefCountForOldProject'

export const versionBackwardCompatibilityBefore = async (project, version, projectId) => {
  if (compareVersions(version, PROJECT_BACK_COMPATIBILITY_BEFORE) <= 0) {
    project.layers.forEach(l => {
      const assetsSortedByStartTime = l.assets
        .sort((a, b) => b.startTime - a.startTime)
        .sort(a => a instanceof ProjectTransitionAsset ? 1 : -1)

      correctAssets(assetsSortedByStartTime)
    })
  }
  if (compareVersions(version, FRONTEND_COMPATIBILITY_BEFORE_2_5_332) <= 0) {
    project.layers.forEach(l => correctAssetWidthNHeight(l.assets))
  }
  if (compareVersions(version, FRONTEND_COMPATIBILITY_BEFORE_2_5_370) <= 0) {
    await updateSourceMediaRefCountForOldProject(project, projectId)
  }
}
